import { DEFAULT_GENERAL_SETTINGS } from './generalSettings';

/**
 * Обновляет PWA-метаданные (название для установки на телефон) из настроек.
 */
export function applyPwaMeta(settings?: API.GeneralSettings): void {
  const name = settings?.platformName || DEFAULT_GENERAL_SETTINGS.platformName || 'RustDesk Console';
  const setMeta = (attr: 'name' | 'property', key: string, value: string) => {
    let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.content = value;
  };
  setMeta('name', 'apple-mobile-web-app-title', name);
  if (settings?.logoUrl) {
    let el = document.head.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
    if (!el) {
      el = document.createElement('link');
      el.rel = 'apple-touch-icon';
      document.head.appendChild(el);
    }
    el.href = settings.logoUrl;
  }
}
